var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState } from 'react';
import { useFetch, usePromise } from '@rad/hooks';
import { DEFAULT_PARCEL_KIND } from '../../../../client/types';
import { getParcels, createParcel } from '../../../common/network/parcels';
import AddressSearchField from './address-search-field';
import { useToast } from '../../../contexts/toast';
export const emptyAddressForm = { parcelIds: [''] };
const AddressField = ({ selected, parcels, onSelect }) => {
    var _a;
    const toast = useToast();
    const [query, setQuery] = useState((_a = selected === null || selected === void 0 ? void 0 : selected.address) !== null && _a !== void 0 ? _a : '');
    const [confirmed, setConfirmed] = useState(!!selected);
    const [resolving, setResolving] = useState(false);
    const select = (parcel) => {
        setQuery(parcel.address);
        setConfirmed(true);
        onSelect(parcel);
    };
    const handleQueryChange = (value) => {
        setQuery(value);
        setConfirmed(false);
    };
    const handleCandidateChosen = (candidate) => __awaiter(void 0, void 0, void 0, function* () {
        const dbMatch = parcels.find(p => p.address.toLowerCase() === candidate.address.toLowerCase());
        if (dbMatch) {
            select(dbMatch);
            return;
        }
        setResolving(true);
        try {
            const created = yield createParcel({
                point: candidate.location,
                address: candidate.address,
                kind: DEFAULT_PARCEL_KIND,
            })();
            select(created.parcel);
        }
        catch (_a) {
            toast.error('Could not add that address. Please try again.');
        }
        finally {
            setResolving(false);
        }
    });
    return (_jsx(AddressSearchField, { parcels: parcels, query: query, onQueryChange: handleQueryChange, confirmed: confirmed, busy: resolving, onParcelChosen: select, onCandidateChosen: handleCandidateChosen, label: "Address", placeholder: "Enter street address, city, state" }));
};
export const PropertyAddressForm = ({ parcelIds, onChange }) => {
    var _a;
    const [parcelOptionsPromise, refetchParcels] = useFetch(getParcels);
    const parcels = (_a = usePromise(parcelOptionsPromise)) !== null && _a !== void 0 ? _a : [];
    const addAddressRow = () => onChange({ parcelIds: [...parcelIds, ''] });
    const removeAddressRow = (index) => onChange({ parcelIds: parcelIds.filter((_, i) => i !== index) });
    const selectParcel = (index, parcel) => {
        const updated = [...parcelIds];
        updated[index] = parcel.id;
        onChange({ parcelIds: updated });
        refetchParcels();
    };
    return (_jsxs(_Fragment, { children: [parcelIds.map((val, i) => (_jsxs("div", { className: "row g-2 mt-1 align-items-center", children: [_jsx("div", { className: "col-10", children: _jsx(AddressField, { selected: parcels.find(p => p.id === val), parcels: parcels, onSelect: (parcel) => selectParcel(i, parcel) }) }), _jsx("div", { className: "col-2", children: _jsx("button", { type: "button", onClick: () => removeAddressRow(i), className: "btn btn-outline-secondary", "aria-label": "Remove this address", children: "Remove" }) })] }, i))), _jsx("div", { className: "row g-2 mt-1", children: _jsx("button", { type: "button", onClick: addAddressRow, className: "signup-button", children: "Add Address" }) })] }));
};
